import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Amplify from "aws-amplify";
import vuetify from "./plugins/vuetify";
import awsconfig from "./aws-exports";
import Vuelidate from "vuelidate";
import { VueMaskDirective } from "v-mask";
import Gravatar from "vue-gravatar";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import DefaultLayout from "./layouts/DefaultLayout";
import FullPageLayout from "./layouts/FullPageLayout";
import browserDetect from "vue-browser-detect-plugin";

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: "eu-west-2:f49bffc9-84d2-4f7f-8a37-e2f0a750487c",

    // REQUIRED - Amazon Cognito Region
    region: "eu-west-2",

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: "eu-west-2_2HVDIm7Ho",

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: "6rq15a8q7ofmqd9m8b0a943f6h",

    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS"
  },
  Storage: {
    AWSS3: {
      bucket: "hp-internal-document-storage",
      region: "eu-west-2"
    }
  }
});

// Manually add hpuser lambder api
awsconfig.aws_cloud_logic_custom.push({
  name: "hpManageUserApi",
  endpoint: "https://l1qepgvg1b.execute-api.eu-west-2.amazonaws.com/master",
  region: "eu-west-2"
});

Amplify.configure(awsconfig);

Vue.component("v-gravatar", Gravatar);

Vue.config.productionTip = false;

Vue.use(Vuelidate);

Vue.directive("mask", VueMaskDirective);

Vue.use(require("vue-moment"));

Vue.use(browserDetect);

Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.component("DefaultLayout", DefaultLayout);
Vue.component("FullPageLayout", FullPageLayout);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

// Let's style this up
require("./assets/style.css");
